import React from 'react';
import cls from 'clsx';
import { md } from '@link/share/vendors';
import styles from './markdown.module.css';

export interface IReactMarkdownProps {
  source?: string;
  className?: string;
}

function renderMarkdownToHTML(markdown: string) {
  // This is ONLY safe because the output HTML
  // is shown to the same user, and because you
  // trust this Markdown parser to not have bugs.
  const renderedHTML = md.render(markdown);
  return { __html: renderedHTML };
}
const ReactMarkdown: React.FC<IReactMarkdownProps> = ({
  className = '',
  source = ''
}) => {
  const markup = renderMarkdownToHTML(source);
  return (
    <div
      className={cls(styles.markdown, className)}
      dangerouslySetInnerHTML={markup}
    />
  );
};

export default ReactMarkdown;
